import './App.css';
import Header from './components/Header';
import HomePage from './pages/HomePage';
import RulesPage from './pages/RulesPage';
import TimelinePage from './pages/TimelinePage';

function App() {
  return (
    <div className="App">
      <Header />
      <HomePage />
      <TimelinePage />
      <RulesPage />
    </div>
  );
}

export default App;